export default __webpack_public_path__ + "static/media/lining24.8c9eabe8.jpeg";